import { Component, OnInit, Injector, OnDestroy, ViewEncapsulation, enableProdMode, ViewChild, ElementRef } from '@angular/core';
import { AuthNoticeService } from './../../../app/core/auth/auth-notice/auth-notice.service';
import { AuthNotice } from './../../../app/core/auth/auth-notice/auth-notice.interface';
import { BaseComponent } from '../../../app/views/theme/base/base.component';
import { AppComponentBase } from '../../../shared/app-component-base';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModalComponent } from '../custom-modal/custom-modal.component';
import { ExcelService } from '../../service/excel.service';
import { HttpClient } from '@angular/common/http';
import { pipe, Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotifyService } from 'abp-ng2-module/dist/src/notify/notify.service';
import sweetalert from 'sweetalert';
import { UIMessage } from '../../../shared/helpers/UIMessage';



interface data {
  PSKodu: number,
  Mno: string,
  MusteriAdi: string,
  MagazaAdi: string,
  Adres: string,
  Ilce: string,
  Il: string,
  Enlem: number,
  Boylam: number,
  Kanal: string,
  Distributor: string,
  UmeId: number,
  Ume: string,
  UmeMail: string,
  UmeTelefon: string,
  UmeHeadId: number,
  UmeHead: string,
  UmeHeadMail: string,
  UmeHeadTelefon: string,
  FoeId: number,
  Foe: string,
  FoeMail: string
}


@Component({
  selector: 'kt-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class MenuComponent extends AppComponentBase implements OnInit, OnDestroy {

  currentOrientation = 'horizontal';
  excelUrl = 'http://api.perabayi.net/umerch/api/transpop/magaza';
  unileverData : data[] ;
  excelDataIsLoading : BehaviorSubject<boolean>;

  @ViewChild('divLoading', {static: true}) myDiv: HTMLDivElement;

  constructor(
    injector: Injector,
    private noticeService: AuthNoticeService,
    private modalService: NgbModal,
    private excelService: ExcelService,
    private http: HttpClient,
    private notifyService: NotifyService

  ) {
    super(injector);
    this.excelDataIsLoading = new BehaviorSubject<boolean>(false);
  }

  ngOnInit() {
    this.noticeService.setNotice("Selam nasilsin?", "danger");
    
  }

  ngOnDestroy() {
    this.noticeService.setNotice(null);
  }

  noticeMessageDegistir() {
    //Mesajlarda coklu dil bu sekilde AppComponentBase ana sinifi icinde l methodu icinden alinacak.
    this.noticeService.setNotice(super.l("AUTH.GENERAL.FORGOT_BUTTON"), "info");
  }

  openModal1(content) {
    this.modalService.open(content);
  }

  openModal2() {
    const modalRef = this.modalService.open(CustomModalComponent);
    modalRef.componentInstance.title = 'Baslik Burada';
  }

  excelLoadingSetValue(loadingStatus) : void{
    this.excelDataIsLoading.next(loadingStatus);
  }

  excelLoadingGetValue() : Observable<boolean>{
    return this.excelDataIsLoading.asObservable();
  }
  

  excelDonwnload() {
    console.log("Dugmeye basildi!");
    this.excelLoadingSetValue(true);


    const data$ = this.http.get<data[]>(this.excelUrl)

    data$.subscribe(resData => {
      this.unileverData = resData
      console.log(this.unileverData.length);
      console.log(this.unileverData[0]);
      
      this.excelService.exportAsExcelFile(this.unileverData,'testUnilever', null);
      
    }, () => {}, 
      () => {
      
        this.excelLoadingSetValue(false);
        console.log("İslem tamamladi");
      }
    );

    
    
  }

  gotoReport1(e) {
    this.uiMessage.modal.success('Dikkat','Iyiyim tesekkurler',()=>{
      this.uiMessage.modal.warning('Gercekten','İyi misin', null);
    });

    
  }

  gotoReport2(e) {
    //abp.message.error("Selam", "Nasilsin iyi misin", false);
    //abp.notify.info("Selam", "Baslik");
    //this.notifyService.info("Selam", "Namer");
    //abp.ui.setBusy('#divLoading');
    // var t = abp.session.userId;
    // alert(t);

    //sweetalert({title:'Dikkat',text:'Aferim cok guzel oldu',icon:'info'});
    // var alert = new UIMessage();
    // alert.modal.info("Modal","Selam ben bir modal'im",null);
    // alert.toast.info("d","das",null);

    this.uiMessage.modal.info('Dikkat','Nasilsin diye soracaktim',null);
  }

}
